module.exports = __webpack_public_path__ + "static/media/cso_loading.8a601c88.gif";